import { useEffect } from "react";

import { useNavigate } from "common/router/hooks";

import { urls } from "client/routes";

import StepLayout from "./CheckoutStepLayout";

import styles from "../styles/EmptyCart.module.less";

const EmptyCart = () => {
  const navigate = useNavigate();

  // Give the user a few seconds to read the messaging, then redirect
  useEffect(() => {
    setTimeout(() => navigate(urls.home.root()), 5000);
  }, [navigate]);

  return (
    <StepLayout>
      <StepLayout.Section>
        <StepLayout.Header>
          <StepLayout.Title>Your cart is empty!</StepLayout.Title>
          <StepLayout.Description>
            You will be redirected to the homepage shortly. If you are not redirected,{" "}
            <button
              type="button"
              onClick={() => navigate(urls.home.root())}
              className={styles.link}
            >
              click here
            </button>
            .
          </StepLayout.Description>
        </StepLayout.Header>
      </StepLayout.Section>
    </StepLayout>
  );
};

export default EmptyCart;
